import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Modal } from 'react-bootstrap';

const DialogModal = ({
  message,
  showModal,
  handleClose,
  response,
  title = 'Confirmar Ação',
  confirmText = 'Sim',
  cancelText = 'Não',
  confirmButtonVariant = 'primary'
}) => {
  return (
    <Modal show={showModal} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>
          <FontAwesomeIcon
            icon={faExclamationTriangle}
            className="me-2 text-warning"
          />
          {title}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>{message}</Modal.Body>
      <Modal.Footer>
        <Button variant="falcon-default" onClick={handleClose}>
          {cancelText}
        </Button>
        <Button variant={confirmButtonVariant} onClick={() => response(true)}>
          {confirmText}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DialogModal;
